<template>
  <v-dialog class="delete-emoji-dialog" v-model="deleteEmojiVisible" width="360px">
    <v-card class="container-delete-emoji pa-5" color="#21343b" width="auto">
      <v-row class="container-emoji" no-gutters align="center" align-content="center" justify="space-between">
        <v-col class="mt-2" :cols="12" align="center" justify="center">
          <span class="content-delete-emoji">Are you sure you want to delete the emoji?</span>
        </v-col>
        <v-col class="ml-4 mt-5" :cols="5" align="center" justify="center">
          <v-btn width="100%" height="40" elevation="0" color="#ff575f" @click="confirm" class="btn-delete-emoji">
            {{ $t('yes') }}
          </v-btn>
        </v-col>
        <v-col class="mr-4 mt-5" :cols="5" align="center" justify="center">
          <v-btn class="btn-delete-emoji" width="100%" height="40" elevation="0" color="#869399" @click="close">
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DeleteEmojiDialog',
  props: ['deleteEmojiVisible'],
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
  computed: {
    ...mapState({
      totalSectionList: (state) => state.clip.totalSectionList,
      sectionIndex: (state) => state.clip.sectionIndex,
    }),
  },
}
</script>

<style scoped>
.container-emoji {
  font-size: 14px;
  color: #96a7af;
}
.btn-delete-emoji {
  color: white;
  font-size: 14px;
  text-transform: none;
}

.container-delete-emoji {
  border-radius: 10px;
}
</style>
